import React from "react";
import {
    Row,
    Form,
    Button,
} from "antd";
import TextField from "../Common/TextField";
import TextEditor from "commons/TextEditor/TextEditor";
import { useSelector, useDispatch } from "react-redux";
import updateStyling from "utility/UpdateChatStreamPreviewStyling";
import { welcomePopupItemUpdated } from "store/actions/WebchatBrandingElementsAction";


export default function WebchatBrandingTabMenuWelcomePopup() {
    const dispatch = useDispatch();
    const { previewState } = useSelector((state) => state.WebchatBrandingElementsReducer);
    const WELCOME_TITLE_TEXT = "WelcomeTitleText";
    const WELCOME_BODY_TEXT = "WelcomeBodyText";
    const WELCOME_BUTTON_TEXT = "WelcomeButtonText";
    
    const welcomePopupData = [
        { "key": "welcomeModalDisplayed","value": true },
        { "key": "welcomeTitleText","value": previewState[WELCOME_TITLE_TEXT] },
        { "key": "welcomeBodyText","value": previewState[WELCOME_BODY_TEXT] },
        { "key": "welcomeButtonText","value": previewState[WELCOME_BUTTON_TEXT] }
    ] 

    const configurationUpdated = (field, data) => {
        const element = welcomePopupData.find(x => x.key.toLocaleLowerCase() === field.toLocaleLowerCase())
        if (element === undefined) {
            console.error(`No element configured for field:${field}`)
        }
        if (data.trim() === element.value.trim()) {
            return;
        }
        element.value = data;
        previewWelcomePopup()
        dispatch(welcomePopupItemUpdated(field, data))
    }

    const previewWelcomePopup = () => {
        updateStyling(document.getElementById('timothyPwaIFrame').contentWindow.window, "WelcomePopup", welcomePopupData);
    }


    return (
        <div className="ant-collapse-content-box">
            <p>The settings below will control how the Welcome screen is presented to your customers</p>
           <Button
                className="standard-button primary-dark-blue-button"
                style={{ marginLeft: 10,marginBottom: 20 }}
                onClick={() => {
                    previewWelcomePopup(true);
                }}
                >
                Preview Welcome Popup
            </Button>
            <Row gutter={[10, 10]} style={{ marginLeft: 10 }}>
                <Form>
                    <Form.Item
                        name={WELCOME_TITLE_TEXT}
                    >
                        <TextField
                            label="Title"
                            initialValue={previewState[WELCOME_TITLE_TEXT]}
                            onChange={(value) => {
                                configurationUpdated(WELCOME_TITLE_TEXT, value)
                            }}
                            placeholder={previewState[WELCOME_TITLE_TEXT]}
                        />
                    </Form.Item>
                
                    
                    <Form.Item
                            name={WELCOME_BODY_TEXT}
                        >
                    <TextEditor
                        label="Body"
                        initialHtmlContent={previewState[WELCOME_BODY_TEXT]}
                        onChange={(value) => {
                            configurationUpdated(WELCOME_BODY_TEXT, value);
                        }}
                        style={{ width: "100%"}}
                        />
                    </Form.Item>

                    <Form.Item
                            name={WELCOME_BUTTON_TEXT}
                        >
                    <TextField
                            label="Close Button Text"
                            initialValue={previewState[WELCOME_BUTTON_TEXT]}
                            onChange={(value) => {
                                configurationUpdated(WELCOME_BUTTON_TEXT, value)
                            }}
                            placeholder={previewState[WELCOME_BUTTON_TEXT]}
                        />
                    </Form.Item>

                </Form>
            </Row>
        </div>
    );
}
